import React, { FunctionComponent } from 'react'
import { LineItemDiscountPercent } from '../LineItemDiscountPercent'
import { LineItemMarkupPercent } from '../LineItemMarkupPercent'
import { LineItemPrice } from '../LineItemPrice'
import { LineItemQuantity } from '../LineItemQuantity'
import { LineItemDiscountError } from '../input-error-message/LineItemDiscountError'
import { LineItemPriceError } from '../input-error-message/LineItemPriceError'
import { LineItemQuantityError } from '../input-error-message/LineItemQuantityError'
import { NoReturnPermissionError } from '../input-error-message/NoReturnPermissionError'
import { LineItemSplitQuantityButton } from '../split-quantity/LineItemSplitQuantityButton'
import { LineItemProductDetailsButton } from '../LineItemProductDetailsButton'
import { LineItemNote } from '../LineItemNote'
import { SalesPersonSelect } from '../SalesPersonSelect'
import {
  LineItemDisplayDetailsProps,
  useLineItemDisplayDetailsModel,
} from './useLineItemDisplayDetailsModel'

export const LineItemDisplayDetails: FunctionComponent<LineItemDisplayDetailsProps> = props => {
  const model = useLineItemDisplayDetailsModel(props)

  return (
    <div className="uc-base">
      <div className="flex flex-col gap-4 pb-3 w-full">
        <div className="flex">
          <div className="li-cell-actions typography-body-sm">
            <LineItemQuantity
              lineItem={model.lineItem}
              editAllowedForConfirmed={model.editAllowedForConfirmed}
              onError={model.onQuantityError}
              ref={model.quantityInputRef}
              readonly={model.readonly}
            />
            <LineItemQuantityError lineItem={model.lineItem} />
          </div>

          <div className="li-cell-actions typography-body-sm">
            <LineItemPrice
              lineItem={model.lineItem}
              editAllowedForConfirmed={model.editAllowedForConfirmed}
              onError={model.onPriceError}
              error={model.priceError}
              hasUserSwitched={() => model.hasUserSwitched}
              ref={model.priceInputRef}
              readonly={model.readonly}
            />
            <LineItemPriceError lineItemID={model.lineItem.localId} />
          </div>

          {model.isPriceMarkedUp ? (
            <div className="li-cell-actions pro-line-item-markup vd-util-text-overflow-break-word typography-body-sm">
              <LineItemMarkupPercent lineItem={model.lineItem} />
            </div>
          ) : (
            <div className="li-cell-actions pro-line-item-discount typography-body-sm">
              <LineItemDiscountPercent
                lineItem={model.lineItem}
                editAllowedForConfirmed={model.editAllowedForConfirmed}
                onError={model.onDiscountError}
                error={model.discountError}
                hasUserSwitched={() => model.hasUserSwitched}
                readonly={model.readonly}
              />
              <LineItemDiscountError lineItemID={model.lineItem.localId} />
            </div>
          )}
        </div>

        <NoReturnPermissionError lineItem={model.lineItem} />

        <div className="pt-1">
          <LineItemNote
            lineItem={model.lineItem}
            editAllowedForConfirmed={model.editAllowedForConfirmed}
          />
        </div>

        {model.showSplitQuantityButton && (
          <div>
            <LineItemSplitQuantityButton
              lineItem={model.lineItem}
              editAllowedForConfirmed={model.editAllowedForConfirmed}
            />
          </div>
        )}

        <div className="flex justify-between items-center">
          {model.showSalePerson && model.loggedInUser ? (
            <div className="max-w-[60%]">
              <SalesPersonSelect lineItem={model.lineItem} />
            </div>
          ) : null}

          <div className="flex-1">
            <LineItemProductDetailsButton productId={model.productId} />
          </div>
        </div>
      </div>
    </div>
  )
}
